<template>
    <v-container>
        <v-dialog v-model="saveMealDialog" max-width="800px">
            <save-as-meal-form @snackbar="displaySnackbar" :dialog.sync="saveMealDialog" />
        </v-dialog>

        <v-card class="flat-card mb-2" flat>
            <v-card-text>
                <v-layout>
                    <v-flex xs3>
                        <v-select :items="diets" v-model="diet" label="Select diet targets" item-text="name" item-value="id" @input="loadTargets"></v-select>
                    </v-flex>
                    <v-flex xs9 class="text-xs-right">
                        <v-btn @click="saveMealDialog = true" color="blue-grey" class="white--text" :disabled="!mealFood || mealFood.length === 0">Save meal<v-icon right dark>save</v-icon></v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>

        <MealTable :diet="diet" />

        <v-snackbar
                v-model="snackbar"
                :timeout="timeout"
                :color="snackbarColor"
                top
        >
            <strong>{{ snackbarText }}</strong>
            <v-btn
                    color="white"
                    text
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import MealTable from './partials/MealTable';
    import SaveAsMealForm from './partials/SaveAsMealForm';

    export default {
        components: {MealTable, SaveAsMealForm},
        data: () => ({
            saveMealDialog: false,
            snackbar: false,
            snackbarText: '',
            snackbarColor: '',
            timeout: 4000,
            diet: 1
        }),
        methods: {
            displaySnackbar(msg, color) {
                this.snackbarText = msg;
                this.snackbarColor = color;
                this.snackbar = true;
            },
            async loadTargets() {
              try {
                if (!this.targets[this.diet]) {
                  this.loading = true;
                  await this.$store.dispatch('getNutrientTargets', this.diet);
                }
              } catch (e) {
                this.displaySnackbar(e.message, 'error');
              } finally {
                this.loading = false;
              }
            }
        },
      computed: {
        ...mapGetters({
            diets: 'getDiets',
            mealFood: 'getMealFood',
            targets: 'getTargets'
        }),
        selectedDiet() {
          return this.diets.find((item) => item.id === this.diet) ;
        }
      }
    };
</script>

<style>

</style>
